// Permissions only. Shared table methods are in tableMixin.js.
export default {
    name: "Permissions",
    methods: {
        clearForm() {
            this.isEditing = false;
            this.isSaving = false;
            this.submitted = false;
            this.formInputs.id = "";
            this.formInputs.permission = "";
            this.formInputs.category = "";
            this.formInputs.name = "";
            this.$clearValidationStates("#recordForm");
        },
    },
};